import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme";
import Layout from "@/components/Layout";
import ExternalRedirect from "@/components/ExternalRedirect";
import Home from "@/pages/Home";
import IgniteHealth from "@/pages/IgniteHealth";
import NYLanding from "@/pages/NYLanding";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLeads from "@/pages/AdminLeads";
import { PAPERFORM_URL } from "@/lib/leads";
import "@/App.css";

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <Routes>
                    {/* Marketing layout (header + footer) */}
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        {/* /benefits merged into /benefits/ignite-health */}
                        <Route path="/benefits" element={<Navigate to="/benefits/ignite-health" replace />} />
                        <Route path="/benefits/ignite-health" element={<IgniteHealth />} />
                        <Route path="/ny" element={<NYLanding />} />
                        <Route path="/new-york" element={<Navigate to="/ny" replace />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>

                    {/* Legacy form routes — Paperform is the single form now */}
                    <Route path="/proposal" element={<ExternalRedirect to={PAPERFORM_URL} />} />
                    <Route path="/representative" element={<ExternalRedirect to={PAPERFORM_URL} />} />

                    {/* Admin */}
                    <Route path="/admin/leads" element={<AdminLeads />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
        </ThemeProvider>
    );
}

export default App;
